<template>
  <div>
    <header-page :namePage="$t('pagesTitles.mc')" :links="$store.state.user.segmentM1Distribution ? $store.state.headerLinks.managerMcLinksWithTimetable : $store.state.headerLinks.managerMcLinks"/>
    <div class="content">
      <select-date-mk
        :title="$t('mc.slots.title')"
        type="new-mk"
      />
    </div>
  </div>
</template>

<script>
import SelectDateMk from "@/components/MK/SelectDateMk.vue"
export default {
  components: {
    SelectDateMk,
  },
}
</script>
